<template>
  <ts-panel>
    <ts-panel-wrapper class="tw-space-y-2">
      <h1 class="section-divider-underline">
        {{ $t("evaluationExamination.candidate") }}
      </h1>
      <div class="col-12 tw-space-y-4">
        <div class="row tw-space-y-2">
          <label class="form-col-label control-label">{{
            $t("evaluationExamination.courseSkill")
          }}</label>
          <a-select
            class="col-md-12"
            show-search
            option-filter-prop="children"
            allowClear
            placeholder="Examination event|Skill|Trainer|Exam Date|Time"
            v-model="course_skill_id"
            @change="onExamEventChange"
          >
            <a-select-option
              v-for="(courseSkill, index) in formViewDatas['courseSkills']"
              :key="index"
              :value="courseSkill.course_skill_id"
            >
              {{ courseSkill.examination_event }}|
              {{ courseSkill.levelskill.level_skill_name }} | Skill:
              {{ courseSkill.levelskill.skill_name_en }} |
              {{ courseSkill.trainer.full_name_en }}|
              {{ courseSkill.exam_date }}
            </a-select-option>
          </a-select>
          <div class="invalid-feedback" v-if="errors.has('course_skill_id')">
            {{ errors.first("course_skill_id") }}
          </div>
        </div>

        <div class="row">
          <div class="col-12 tw-space-y-1">
            <label class="required">{{
              $t("evaluationExamination.issueDate")
            }}</label>
            <a-date-picker
              v-model="model.issue_date"
              style="width: 100%"
              placeholder="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
              format="DD-MM-YYYY"
              @change="onChangeIssueDate"
            />
            <div class="invalid-feedback" v-if="errors.has('issue_date')">
              {{ errors.first("issue_date") }}
            </div>
          </div>
        </div>

        <div class="col-12">
          <label class="form-label col-form-label col-md-12">{{
            $t("search")
          }}</label>
          <div class="col-md-12">
            <input type="text" v-model="search" class="form-control" />
          </div>
        </div>
        <div class="tw-overflow-y-scroll row tw-h-96" style="max-height: 50vh">
          <ts-loading-banner :loading="loading">
            <table class="tw-w-full">
              <thead>
                <tr
                  class="tw-uppercase tw-bg-gray-200 tw-h-10 tw-sticky tw-top-0"
                >
                  <!-- <th class="tw-whitespace-no-wrap tw-pl-2" style="width: 20%">
                    {{ $t("evaluationExamination.cardNumber") }}
                  </th> -->
                  <th class="tw-whitespace-no-wrap tw-pl-2" style="width: 25%">
                    {{ $t("evaluationExamination.nameEn") }}
                  </th>
                  <th
                    class="tw-whitespace-no-wrap tw-text-center"
                    style="width: 10%"
                  >
                    {{ $t("evaluationExamination.sex") }}
                  </th>
                  <th class="tw-whitespace-no-wrap" style="width: 20%">
                    {{ $t("evaluationExamination.registerDate") }}
                  </th>
                  <th class="tw-whitespace-no-wrap" style="width: 20%">
                    {{ $t("evaluationExamination.phone") }}
                  </th>
                  <th style="width: 5%"></th>
                </tr>
              </thead>
              <tbody>
                <td
                  v-if="!formViewDatas['examRegisters'][0]"
                  colspan="5"
                  class="tw-text-center tw-h-10"
                >
                  No Data
                </td>
                <tr
                  v-for="(examRegister, index) in examRegisterCadidates"
                  :key="index"
                  id="row"
                  class="
                    tw-cursor-pointer
                    hover:tw-bg-gray-300
                    tw-w-full tw-h-10
                  "
                  :class="{
                    active: current_active == examRegister.exam_register_id,
                  }"
                  @click="setModelData(examRegister)"
                >
                  <!-- <td class="tw-whitespace-no-wrap tw-pl-2">
                    {{ examRegister.card_number }}
                  </td> -->
                  <td class="tw-whitespace-no-wrap tw-pl-2">
                    {{ examRegister.fname_en }} {{ examRegister.lname_en }}
                  </td>
                  <td class="tw-whitespace-no-wrap tw-text-center">
                    {{ examRegister.sex }}
                  </td>
                  <td class="tw-whitespace-no-wrap">
                    {{ examRegister.register_date }}
                  </td>
                  <td class="tw-whitespace-no-wrap">
                    {{ examRegister.phone }}
                  </td>
                  <td
                    class="
                      tw-whitespace-no-wrap tw-text-green-500 tw-text-center
                    "
                  >
                    <a-icon type="plus-circle" class="tw-text-lg" />
                  </td>
                </tr>
              </tbody>
            </table>
          </ts-loading-banner>
        </div>
      </div>
    </ts-panel-wrapper>
  </ts-panel>
</template>

<script>
import { Errors } from "form-backend-validation";
import { mapActions, mapState } from "vuex";

export default {
  name: "exam-schedule",
  props: ["value", "validation"],
  data() {
    return {
      search: "",
      loading: false,
      model: {},
      course_skill_id: null,
      errors: new Errors(),
      options: null,
      current_active: null,
    };
  },
  created() {
    this.model = this.value;
  },
  computed: {
    ...mapState("academic/evaluationExamination", [
      "formViewDatas",
      "edit_data",
    ]),
    examRegisterCadidates() {
      if (!this.formViewDatas["examRegisters"]) return [];
      return this.formViewDatas["examRegisters"]
        .filter(
          (c) =>
            this.search
              .split(" ")
              .every(
                (s) =>
                  c.fname_en.toLowerCase().includes(s.toLowerCase()) ||
                  c.lname_en.toLowerCase().includes(s.toLowerCase())
              ) ||
            this.search
              .split(" ")
              .every((s) =>
                c.card_number.toLowerCase().includes(s.toLowerCase())
              )
        )
        .slice(0, 400);
    },
  },
  methods: {
    ...mapActions("academic/evaluationExamination", ["getFormViewData"]),
    async onExamEventChange() {
      this.$emit("clearError");
      this.search = "";
      this.loading = true;
      await this.getFormViewData({
        index: "examRegisters",
        params: {
          fnName: "examRegisters",
          course_skill_id: this.course_skill_id,
        },
      });
      this.setModelData(this.formViewDatas["examRegisters"][0]);
      this.loading = false;
    },
    onChangeIssueDate(dateString) {
      this.model.issue_date = dateString;
    },
    removeCadidate() {
      var index = this.formViewDatas["examRegisters"].indexOf(
        this.formViewDatas.examRegisters.find(
          (e) =>
            e.exam_register_id == this.model.evaluation_list[0].exam_register_id
        )
      );
      this.formViewDatas["examRegisters"].splice(index, 1);
    },
    clearOption() {
      this.model.status_reason_id = null;
      this.options = null;
    },
    setModelData(examRegisters) {
      this.model.candidate = [];
      this.model.evaluation_list = [];

      if (examRegisters) {
        this.current_active = examRegisters.exam_register_id;
        var schedule = this.formViewDatas["courseSkills"];
        if (schedule != undefined && this.course_skill_id != null) {
          //Set Data To Cadidate Select

          let skill = schedule.find(
            (s) => s.course_skill_id == this.course_skill_id
          ).levelskill.level_skill_name;
          this.model.candidate.push({
            exam_register_id: examRegisters.exam_register_id,
            candidate_id: examRegisters.candidate_id,
            card_number: examRegisters.card_number,
            candidate_name_en:
              examRegisters.fname_en + " " + examRegisters.lname_en,
            level_skill_name: skill,
            phone: examRegisters.phone,
            register_date: examRegisters.register_date,
            sex: examRegisters.sex,
          });
          //Set Subject And Data to Evaluation

          let subject = schedule.find(
            (s) => s.course_skill_id == this.course_skill_id
          ).subjects;
          subject.forEach((el) => {
            this.model.evaluation_list.push({
              exam_register_id: examRegisters.exam_register_id,
              subject_profile_id: el.subject_profile_id,
              subject_name_en: el.subject_name_en,
              is_passed: false,
              remarks: null,
            });
          });
        }
      }
    },
  },
  watch: {
    validation: {
      handler() {
        this.errors = new Errors(this.validation.errors);
      },
      deep: true,
    },
  },
};
</script>

<style lang="css" scoped>
.section-divider-underline {
  padding-bottom: 5px;
  margin: 0 0 8px 0;
  /* border-bottom: 1px solid #eee; */
  font-size: 16px;
  color: #929090;
  font-weight: 400;
  text-transform: uppercase;
}
.active {
  background: rgba(209, 213, 219);
}
</style>
